
import axiosInstance from "./axios";

const contactService = async (data: {
    name: string;
    email: string;
    phone: string;
    topic: string;
    message: string;
    website?: string;
}) => {
    try {
        const response = await axiosInstance.post("api/scheduleDemo/contact-us", data); // Adjust backend route if needed
        console.log(response)
        return response.data;
    } catch (error) {
        console.error("Error submitting contact form:", error);
        throw error;
    }
};

export default contactService;
